// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3K4IZ","info":"UpdateTermsInfo_info__NL-1q"};